module.exports = "/assets/data/04689be50f02c0302fd72402f9f2ab74-IP28.data.json";